export const tokenMc = () => {
  const token = localStorage.getItem('token_corregidora');
  return token;
}